import dynamic from 'next/dynamic';
import { BookingErrorMessageProps } from './BookingErrorMessage.types';

export const BookingErrorMessage = dynamic<BookingErrorMessageProps>(() =>
  import('./BookingErrorMessage').then(module => module)
);
